


import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'
import { PillerELDDLAPI } from '../../Redux/DDLSlice'

export const PillerDDL = (props) => {

    const { PillerID, setPillerID, LocationName, WardName,rowData, APIFlag,Flag, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    // const [workTypeID, setLocationName] = useState('')

    useEffect(() => {
        const data = {
            M_ELEC_LocationID:LocationName?.ID,
            Flag: APIFlag,
            M_WardID: WardName?.ID,
            M_UserID: UserID,
            token: token
        }
        dispatch(PillerELDDLAPI({ data }))
    }, [WardName?.ID, LocationName?.ID, IsPost])

    const { PillerData } = useSelector(state => state.PillerELDDLData)

    useEffect(() => {
        console.log('PillerData', PillerData)
        handlePillerDDL()
    }, [PillerData, rowData])

    const handlePillerDDL = () => {
        if (PillerData && PillerData.table && PillerData.table.length > 0) {
            let list = PillerData.table.map((item, index) => ({
                value: item.m_eleC_PillerID,
                label: item.pillerNo,
            }))
            setPillerID({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_eleC_PillerID : 0,
                Label: Flag === 'Update' ? rowData.pillerNo : "Select...",
            })
        }
        else {
            setPillerID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for="" className=""><b>Piller Count</b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: PillerID.ID, label: PillerID.Label }}
                onChange={(e) => {
                    e ?
                        setPillerID({ ...PillerID, ID: e.value, Label: e.label })
                        :
                        setPillerID({ ...PillerID, ID: 0, Label: "Select..." })

                }}
                options={PillerID.DDL}
            />
        </div>
    )
}